export class HttpError extends Error {
  status: number;
  constructor(status: number, message?: string) {
    super(message ?? String(status));
    this.status = status;
  }
}
